/**
 * Shim for SvelteKit $app/* imports in widget builds
 * The widget always runs in a browser environment without SvelteKit routing
 */

// $app/env
export const browser = true;
export const building = false;
export const dev = false;
export const version = '0.0.0';

// $app/state - minimal page state for widget
// $state so standalone components can backfill page.data (e.g. instance) after
// their async fetch resolves, same as real SvelteKit page data - see
// StandaloneChat.svelte / StandaloneAntonioChat.svelte.
export const page = $state({
	url: typeof window !== 'undefined' ? new URL(window.location.href) : new URL('http://localhost'),
	params: {},
	route: { id: null },
	status: 200,
	error: null,
	data: {} as App.PageData,
	form: undefined,
	state: {}
});

// $app/navigation - no-op functions for widget
export function goto() {
	console.warn('goto() not available in widget mode');
}

export function invalidate() {
	console.warn('invalidate() not available in widget mode');
}

export function refreshAll() {
	console.warn('refreshAll() not available in widget mode');
}

export function afterNavigate() {
	// No-op in widget
}

export function beforeNavigate() {
	// No-op in widget
}

// $app/paths - fills in a route ID's params like SvelteKit's resolve(). The widget
// is embedded on other sites, so links point at the app, not the host page.
export function resolve(route: string, params: Record<string, string> = {}) {
	const path = route.replace(
		/\[(?:\.\.\.)?(\w+)(?:=\w+)?\]/g,
		(_, key: string) => params[key] ?? ''
	);
	return `${PUBLIC_APP_URL}${path}`;
}
export const base = '';
export const assets = '';

// $app/env/public - populated from PUBLIC_* env vars at build time (see
// envDir/envPrefix in vite.config.widget-base.ts), falling back to production
// defaults since the widget receives its actual PocketBase URL via constructor.
export const PUBLIC_POCKETBASE_URL = import.meta.env.PUBLIC_POCKETBASE_URL ?? 'https://api.botbakery.app';
export const PUBLIC_APP_URL = import.meta.env.PUBLIC_APP_URL ?? 'https://botbakery.app';
